// Fichiers de traduction séparés — aucune chaîne importante codée en dur dans les composants.
// Ajouter une langue = ajouter une clé de premier niveau ici.
export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      catalogue: "Catalogue",
      sell: "Vendre mes volailles",
      myListings: "Mes volailles disponibles",
      messages: "Échanges",
      dashboard: "Tableau de bord",
      profile: "Mon profil",
      admin: "Administration",
      login: "Connexion",
      register: "Créer un compte",
      logout: "Déconnexion",
      browse: "Parcourir",
      market: "Marché",
      publish: "Publier",
      activity: "Activité",
      myspace: "Mon espace",
      offers: "Les Offres",
    },
    publish: {
      stepOf: "Étape {n} sur {total}",
      steps: { product: "Produit", photo: "Photo", quantity: "Quantité", price: "Prix", place: "Lieu", publish: "Publier" },
      photoHint: "Ajoutez une ou plusieurs photos nettes de votre produit (facultatif mais recommandé).",
      reviewHint: "Vérifiez les informations avant de publier.",
      publishNow: "Publier maintenant",
    },
    space: {
      salesBoard: "Mes ventes",
      ordersBoard: "Mes achats",
      ordersReceived: "Commandes reçues",
      delivered: "Livrées",
      refused: "Refusées",
      revenue: "Chiffre réalisé",
      spend: "Total dépensé",
      inProgress: "En cours",
      myPurchases: "Mes achats",
      myListings: "Mes offres",
      myListingsDesc: "{n} annonce(s) active(s)",
      mySales: "Mes ventes",
      mySalesDesc: "Commandes reçues, livrées, chiffre d'affaires",
      myPurchasesDesc: "Suivez vos commandes en cours et passées",
      myOffersDesc: "Publiez votre besoin et recevez des propositions",
      reputation: "Réputation",
      reputationDesc: "Score, badges et évolution",
      profile: "Profil",
      profileDesc: "Vos informations personnelles",
      settings: "Paramètres",
      settingsDesc: "Modes de versement, langue, déconnexion",
      language: "Langue",
    },
    push: {
      title: "Notifications",
      descOn: "Vous recevez les alertes de commandes, offres et messages sur cet appareil.",
      descOff: "Activez les notifications pour ne rien manquer sur cet appareil.",
      descDenied: "Notifications bloquées. Autorisez-les dans les réglages de votre navigateur ou téléphone, puis réessayez.",
      descUnsupported: "Votre navigateur ne prend pas en charge les notifications.",
      statusOn: "Activées",
      statusOff: "À autoriser",
      statusDenied: "Refusées",
      enable: "Activer les notifications",
      disable: "Désactiver",
      enabling: "Activation…",
      enableFailed: "Impossible d'activer les notifications. Vérifiez les autorisations.",
      enabledOk: "Notifications activées sur cet appareil.",
      disabledOk: "Notifications désactivées sur cet appareil.",
      remindTitle: "Activez les notifications",
      remindDesc: "Soyez alerté de vos commandes, offres et messages, même app fermée.",
      remindLater: "Plus tard",
    },
    offers: {
      title: "Les Offres",
      buyerSubtitle: "Publiez votre besoin, recevez des propositions de vendeurs, choisissez la meilleure.",
      sellerSubtitle: "Répondez aux demandes des acheteurs avec votre prix et votre disponibilité.",
      buyerEmptyTitle: "Vous n'avez aucune offre en cours",
      buyerEmptyText: "Décrivez ce que vous cherchez (produit, quantité, commune, date). Après validation, les vendeurs vous proposeront leurs prix.",
      create: "Créer une offre",
      createTitle: "Nouvelle offre d'achat",
      createSubtitle: "Remplissez votre besoin. L'administration valide avant publication aux vendeurs.",
      product: "Produit recherché",
      quantity: "Quantité",
      deliveryCommune: "Commune de livraison",
      deliveryLocation: "Lieu de livraison",
      neighborhoodRequired: "Indiquez la ville / quartier de livraison.",
      neededBy: "Date souhaitée",
      createdAt: "Créée le", updatedAt: "Modifiée le",
      note: "Commentaire (facultatif)",
      notePlaceholder: "Ex : livraison le matin, volailles vivantes…",
      submit: "Soumettre la demande",
      created: "Offre soumise. En attente de validation par l'administration.",
      communeRequired: "Choisissez la commune de livraison.",
      statusPending: "En attente de validation",
      statusPublished: "Publiée",
      statusSuspended: "Suspendue",
      statusPaused: "En pause",
      pendingNote: "Votre offre est en attente de validation par l'administration. Vous serez notifié dès sa publication.",
      suspendedNote: "Votre offre a été suspendue par l'administration.",
      pausedNote: "Votre offre est en pause : les vendeurs ne la voient plus.",
      resume: "Reprendre",
      pause: "Mettre en pause",
      cancelOffer: "Supprimer l'offre",
      deleteConfirmTitle: "Supprimer cette offre ?",
      deleteConfirmDesc: "Cette action est irréversible. Votre offre et les réponses des vendeurs seront supprimées.",
      deleted: "Offre supprimée.",
      intentExplain: "Pour voir les réponses des vendeurs et lancer une commande, confirmez que votre intention d'achat est sérieuse.",
      confirmIntent: "Je confirme mon intention sérieuse",
      responsesWaiting: "réponse(s) de vendeurs vous attendent",
      noResponsesYet: "Aucune réponse pour le moment.",
      sellerResponses: "Réponses des vendeurs",
      chooseSeller: "Choisir ce vendeur",
      orderStarted: "Commande lancée ! Le vendeur va fixer les frais de livraison.",
      sellerEmpty: "Aucune offre publiée pour le moment. Revenez plus tard.",
      respond: "Répondre",
      editResponse: "Modifier ma réponse",
      respondTitle: "Répondre à cette offre",
      yourPrice: "Votre prix (total)",
      unitPrice: "Prix unitaire",
      total: "Total",
      availability: "Disponibilité",
      availabilityPlaceholder: "Ex : disponible sous 2 jours, livraison possible…",
      sendResponse: "Envoyer ma réponse",
      responseSent: "Réponse envoyée à l'acheteur.",
      respRequired: "Indiquez un prix et votre disponibilité.",
      youProposed: "Votre offre",
      responsesLabel: "réponse(s)",
      counterCta: "Proposer mon prix",
      counterTitle: "Proposer mon prix",
      counterDesc: "Proposez votre prix unitaire au vendeur. Il peut l'accepter ou le refuser.",
      yourCounterPrice: "Votre prix unitaire proposé",
      counterSend: "Envoyer ma proposition",
      counterInvalid: "Indiquez un prix valide.",
      counterSent: "Proposition envoyée au vendeur.",
      counterPending: "Contre-offre envoyée ({p} / unité) — en attente de la réponse du vendeur.",
      counterAccepted: "Le vendeur a accepté votre prix. Vous pouvez finaliser.",
      counterRejected: "Le vendeur a refusé votre prix. Son prix initial reste valable.",
      counterReceived: "Contre-offre de l'acheteur : {p} / unité",
      counterVsYours: "Votre prix initial : {p} / unité",
      accept: "Accepter",
      reject: "Refuser",
      counterAcceptedSeller: "Contre-offre acceptée. Le nouveau prix est appliqué.",
      counterRejectedSeller: "Contre-offre refusée.",
      noPhoneWarning: "Ne partagez aucun numéro de téléphone : les coordonnées ne sont échangées qu'après confirmation du paiement.",
    },
    common: {
      loading: "Chargement…",
      seeAll: "Tout voir",
      search: "Rechercher",
      reset: "Réinitialiser",
      cancel: "Annuler",
      validate: "Valider",
      save: "Enregistrer",
      publish: "Publier",
      edit: "Modifier",
      delete: "Supprimer",
      back: "Retour",
      send: "Envoyer",
      next: "Suivant",
      yes: "Oui",
      no: "Non",
      from: "à partir de",
      demo: "Démonstration",
      verified: "Vérifié",
      pending: "En attente",
      required: "Ce champ est requis",
      community: "Rejoindre la Communauté",
    },
    hero: {
      badge: "Mali",
      searchPlaceholder: "Ex : poulet, œufs, pintade…",
      trust1: "Vendeurs vérifiés",
      trust2: "Livraison locale",
      trust3: "Partout au Mali",
      ctaSignup: "Inscris-toi, c'est gratuit",
      ctaLogin: "Déjà inscrit ? Se connecter",
    },
    home: {
      categoriesTitle: "Parcourir par catégorie",
      categoriesSubtitle: "Choisissez la volaille que vous recherchez.",
      value1Title: "Confiance d'abord",
      value1Text: "Échanges via la messagerie interne, réputation et suivi conservés sur la plateforme.",
      value2Title: "Proximité",
      value2Text: "Achetez auprès d'éleveurs vérifiés près de chez vous.",
      value3Title: "Qualité locale",
      value3Text: "Volailles saines : poulet local, pintade, canard, caille.",
      popularTitle: "Disponibilités récentes",
      popularSubtitle: "Les dernières volailles publiées par nos vendeurs.",
      seeCatalogue: "Voir le catalogue",
      trustedTitle: "Vendeurs de confiance",
      latestTitle: "Derniers produits",
      latestSubtitle: "Poulets et œufs récemment publiés près de chez vous.",
      risingTitle: "Vendeur en forte progression",
      risingGain: "+{n} pts ce mois",
      risingCta: "Voir le profil",
    },
    catalog: {
      title: "Catalogue des volailles",
      subtitle: "Parcourez les disponibilités publiées par les vendeurs vérifiés.",
      resultsFor: "Résultats pour",
      searchPlaceholder: "Rechercher un produit (poulet de chair, œufs, caille…)",
      location: "Ville / quartier / commune",
      locationPlaceholder: "Ex : Bamako, Commune I, Badalabougou…",
      filters: "Filtres",
      category: "Catégorie",
      region: "Région",
      state: "État",
      maxPrice: "Prix maximum",
      deliveryOnly: "Livraison possible uniquement",
      allRegions: "Toutes les régions",
      allStates: "Tous les états",
      sortRecent: "Plus récents",
      sortRecommended: "Recommandés",
      sortPriceAsc: "Prix croissant",
      sortPriceDesc: "Prix décroissant",
      results: "résultat(s)",
      emptyTitle: "Aucune volaille trouvée",
      emptyText: "Essayez d'ajuster vos filtres ou votre recherche.",
    },
    listing: {
      quantity: "Quantité disponible",
      avgWeight: "Poids moyen",
      region: "Région / ville",
      availableFrom: "Disponible à partir du",
      delivery: "Livraison",
      deliveryYes: "Livraison possible",
      deliveryNo: "Retrait sur place",
      seller: "Vendeur",
      exchange: "Échanger",
      exchangeHint: "Les coordonnées personnelles restent masquées. Échangez en toute sécurité via la messagerie interne de la plateforme.",
      continueBrowsing: "Continuer à parcourir",
      relatedTitle: "Dans la même catégorie",
      soldOut: "Épuisé",
      paused: "En pause",
      loginToExchange: "Connectez-vous en tant qu'acheteur pour échanger avec le vendeur.",
      exchangeStarted: "Message envoyé ! Retrouvez l'échange dans « Échanges ».",
    },
    auth: {
      loginTitle: "Connexion",
      loginSubtitle: "Accédez à votre espace Ovolaay Hub.",
      registerTitle: "Créer un compte",
      registerSubtitle: "Rejoignez la marketplace avicole.",
      name: "Nom complet / Nom de la ferme",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordMismatch: "Les mots de passe ne correspondent pas.",
      role: "Je suis un…",
      roleBuyer: "Acheteur",
      roleSeller: "Vendeur",
      region: "Région",
      city: "Ville",
      phone: "Numéro de téléphone",
      phoneHint: "Obligatoire — restera privé (jamais affiché publiquement).",
      chooseRole: "Que voulez-vous faire ?",
      iSell: "Je vends",
      iBuy: "J'achète",
      iSellHint: "Éleveur / vendeur",
      iBuyHint: "Acheter des produits",
      specialty: "Que vendez-vous ?",
      specMultiHint: "Choisissez tous les produits que vous vendez (plusieurs possibles).",
      specRequired: "Choisissez au moins un produit que vous vendez.",
      specPoulet: "Poulets",
      specOeufs: "Œufs",
      specDeux: "Les deux",
      selectRegion: "Région / District",
      selectDistrict: "Commune / Cercle",
      selectCity: "Commune (facultatif)",
      quartier: "Ville / Quartier",
      quartierHint: "Saisie libre (les adresses ne sont pas postales au Mali).",
      loginBtn: "Se connecter",
      identifier: "Email ou téléphone",
      emailOptional: "Email (optionnel)",
      emailOptionalHint: "Pas d'email ? Aucun souci, votre téléphone suffit.",
      forgotPassword: "Mot de passe oublié ?",
      forgotTitle: "Réinitialiser le mot de passe",
      forgotSubtitle: "Recevez un code par email ou via WhatsApp.",
      sendCode: "Envoyer le code",
      codeSent: "Si un compte existe, un code a été généré.",
      codeSentHint: "Saisissez le code reçu (email) ou communiqué par le support WhatsApp, puis votre nouveau mot de passe.",
      code: "Code de réinitialisation",
      newPassword: "Nouveau mot de passe",
      resetBtn: "Réinitialiser",
      resetDone: "Mot de passe réinitialisé. Connectez-vous.",
      linkSent: "Email envoyé ! Vérifiez votre boîte de réception.",
      linkSentHint: "Un lien sécurisé de réinitialisation vient d'être envoyé à votre adresse email. Il expire dans 1 heure. Ouvrez-le depuis votre boîte mail pour choisir un nouveau mot de passe.",
      resetTitle: "Choisir un nouveau mot de passe",
      resetSubtitle: "Saisissez votre nouveau mot de passe.",
      resetNoToken: "Lien de réinitialisation manquant ou invalide. Veuillez refaire une demande.",
      noCodeWhatsapp: "Pas reçu de code ? Contacter le support WhatsApp",
      registerBtn: "Créer mon compte",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      sellerNote: "Votre compte vendeur sera activé après vérification par un administrateur.",
    },
    dashboard: {
      welcome: "Bonjour",
      sellerTitle: "Mes volailles disponibles",
      sellerSubtitle: "Publiez et gérez vos disponibilités.",
      payoutTitle: "Mode de versement préféré",
      payoutHint: "Cochez un ou plusieurs modes et renseignez uniquement ce que vous avez. Aucun champ n'est obligatoire. Ces informations ne sont visibles que par l'administration.",
      payoutSave: "Enregistrer les modes de versement",
      payoutSaved: "Modes de versement enregistrés",
      payoutOrange: "Orange Money",
      payoutWave: "Wave Money",
      payoutMoov: "Moov Money",
      payoutBank: "Virement bancaire",
      payoutPhone: "Numéro de téléphone",
      payoutRib: "RIB / IBAN",
      addListing: "Ajouter une disponibilité",
      noListings: "Vous n'avez encore publié aucune volaille.",
      notVerifiedTitle: "Compte en attente de vérification",
      notVerifiedText: "Un administrateur doit valider votre compte vendeur avant que vous puissiez publier vos volailles.",
      buyerTitle: "Mon espace acheteur",
      buyerSubtitle: "Retrouvez vos échanges avec les vendeurs.",
      active: "Active",
      pause: "Mettre en pause",
      activate: "Réactiver",
    },
    listingForm: {
      title: "Publier une volaille",
      editTitle: "Modifier la volaille",
      category: "Type de volaille",
      state: "État",
      quantity: "Quantité",
      avgWeight: "Poids moyen (ex : 1,8 kg)",
      price: "Prix",
      priceUnit: "Unité de prix",
      region: "Région",
      city: "Ville",
      availabilityDate: "Date de disponibilité",
      delivery: "Livraison possible",
      photos: "Photos",
      addPhotos: "Ajouter des photos",
      comment: "Commentaire",
      commentPlaceholder: "Décrivez vos volailles (alimentation, élevage, conditions…).",
      voiceSoon: "Le commentaire vocal arrivera dans une prochaine version.",
      published: "Volaille publiée avec succès !",
      updated: "Disponibilité mise à jour.",
      updatedRevalidate: "Annonce modifiée — de nouveau en attente de validation.",
      revalidateNote: "Toute modification renvoie l'annonce en validation par l'équipe Ovolaay Hub avant nouvelle publication.",
      takePhoto: "Prendre une photo",
      chooseCategory: "Que vendez-vous ?",
      plateaux: "Nombre de plateaux (30 œufs)",
      perPlateau: "par plateau",
    },
    messages: {
      title: "Mes échanges",
      empty: "Aucun échange pour le moment.",
      selectConversation: "Sélectionnez un échange pour voir les messages.",
      placeholder: "Écrivez votre message…",
      about: "À propos de",
      you: "Vous",
      loadError: "Impossible de charger les conversations.",
      sendError: "Échec de l'envoi. Réessayez.",
      attachError: "Échec de l'ajout de l'image.",
      warnPhone: "Attention : ne concluez pas de vente hors plateforme. Ovolaay décline toute responsabilité en cas d'arnaque. Concluez vos ventes sur la plateforme.",
      makeOffer: "Faire une offre",
      offerTitle: "Faire une offre",
      offerAmount: "Montant total proposé (FCFA)",
      offerQuantity: "Quantité",
      sendOffer: "Envoyer l'offre",
      offerSent: "Offre envoyée",
      offerLabel: "Offre",
      offerFor: "pour {q} unité(s)",
      accept: "Accepter",
      reject: "Refuser",
      offerPending: "En attente de réponse",
      offerAccepted: "Offre acceptée",
      offerRejected: "Offre refusée",
      offerExpired: "Offre expirée",
      offerExpiresHint: "Expire sous 1 heure",
      offerAcceptedToast: "Offre acceptée — commande créée",
      offerRejectedToast: "Offre refusée",
      offerError: "Action impossible sur cette offre.",
      viewOrder: "Voir la commande",
      payNow: "Payer la commande",
      download: "Télécharger",
      yourOffer: "Votre offre",
      expiresInLabel: "Temps restant :",
      payBeforeExpiry: "Payer avant expiration",
      offerAcceptedPinned: "Offre acceptée — commande créée",
      offerAcceptedInfo: "Offre acceptée ! Le vendeur va fixer les frais de livraison, puis vous pourrez payer.",
      feePending: "En attente des frais de livraison du vendeur",
    },
    admin: {
      title: "Administration",
      subtitle: "Gérez les comptes, les vendeurs et les annonces.",
      viewProfile: "Voir la fiche",
      registeredAt: "Inscrit le",
      profileBuyerTitle: "Fiche acheteur",
      profileSellerTitle: "Fiche vendeur",
      profileLoading: "Chargement de la fiche…",
      profileContact: "Coordonnées (admin uniquement)",
      profileKpiOrders: "Commandes",
      profileKpiFinalized: "Finalisées",
      profileKpiRevenue: "Chiffre réalisé",
      profileKpiSpend: "Total dépensé",
      profileListings: "Annonces publiées",
      profileNoListings: "Aucune annonce publiée.",
      profileOrdersSeller: "Historique des ventes",
      profileOrdersBuyer: "Historique des achats",
      profileNoOrders: "Aucune commande pour le moment.",
      profilePublishedOn: "Publié le",
      profileSoldOn: "Vendu le",
      profileOnlineSince: "En ligne depuis {n} j",
      profileLongOnline: "Invendu depuis {n} j",
      profileDateCreated: "Commande",
      profileDatePaid: "Payée",
      profileDateShipped: "Expédiée",
      profileDateDelivered: "Livrée",
      profileDateClosed: "Clôturée",
      buyers: "Acheteurs",
      sellers: "Vendeurs",
      pending: "Vendeurs en attente",
      listings: "Annonces",
      conversations: "Échanges",
      today: "Aujourd'hui",
      newRegistrations: "inscriptions",
      newOrders: "commandes",
      users: "Utilisateurs",
      sellersTab: "Vendeurs",
      listingsTab: "Annonces",
      disputesTab: "Litiges",
      ordersTab: "Commandes",
      setFee: "Frais de livraison",
      setFeeBtn: "Définir les frais",
      validatePayment: "Valider le paiement",
      viewReceipt: "Voir le reçu",
      awaitingFee: "Frais à définir",
      awaitingValidation: "Reçu à valider",
      feeSaved: "Frais enregistrés",
      paymentValidated: "Paiement validé — coordonnées débloquées",
      noOrders: "Aucune commande à traiter.",
      rstTab: "Score RST",
      resolveRefund: "Rembourser l'acheteur",
      resolveRelease: "Libérer au vendeur",
      noDisputes: "Aucun litige pour le moment.",
      disputeDefaultTitle: "Admin ajouté automatiquement aux nouveaux litiges",
      disputeDefaultHint: "Cet administrateur rejoint automatiquement chaque nouveau litige et peut y lire et écrire.",
      disputeDefaultPlaceholder: "Choisir un administrateur",
      disputeDefaultSaved: "Administrateur par défaut enregistré",
      disputeAssigned: "Admin en charge",
      disputeUnassigned: "Aucun",
      disputeOpenConvo: "Ouvrir la conversation",
      disputeTransferPlaceholder: "Transférer à…",
      disputeTransferred: "Litige transféré",
      disputeMsgPlaceholder: "Écrire un message…",
      disputeSend: "Envoyer",
      makePremium: "Nommer Premium RST",
      removePremium: "Retirer Premium",
      verify: "Vérifier",
      unverify: "Retirer la vérification",
      verified: "Vérifié ✅ le vendeur peut publier",
      sellerVerified: "Vendeur vérifié",
      sellerUnverified: "Vendeur non vérifié",
      pendingSellersTab: "Vendeurs en attente",
      verifiedSellersTab: "Vendeurs vérifiés",
      noPendingSellers: "Aucun vendeur en attente de validation.",
      noVerifiedSellers: "Aucun vendeur vérifié.",
      pendingListingsTab: "Annonces en attente",
      buyersTab: "Acheteurs",
      offersTab: "Offres",
      noOffers: "Aucune offre pour le moment.",
      offerPublish: "Publier",
      offerSuspend: "Suspendre",
      offerPause: "Mettre en pause",
      offerUpdated: "Offre mise à jour.",
      offerDeleted: "Offre supprimée.",
      offerCreate: "Créer une offre",
      offerSaveEdit: "Enregistrer",
      offerEditTitle: "Modifier l'offre d'achat",
      offerEditDesc: "Mettez à jour le produit, la quantité, la localisation, la description et le statut.",
      offerUpdated: "Offre mise à jour.",
      offerOptional: "facultatif",
      optional: "facultatif",
      offerBuyerOrName: "Sélectionnez un acheteur ou saisissez un nom d'acheteur externe.",
      offerExternalBuyer: "Acheteur externe (non inscrit)",
      offerExternalBuyerPh: "Nom de l'acheteur",
      offerExternalTag: "Acheteur externe",
      offerStatus: "Statut",
      offerCreated: "Offre créée avec succès.",
      offerCreateTitle: "Créer une offre au nom d'un acheteur",
      offerCreateDesc: "Renseignez le produit, la quantité, la localisation et une description. L'offre apparaîtra dans le même espace que les offres des acheteurs.",
      offersManageHint: "Créez, publiez, suspendez ou supprimez des offres d'achat.",
      offerBuyer: "Acheteur",
      offerPickBuyer: "Choisir un acheteur",
      offerPickProduct: "Choisissez un produit",
      offerProduct: "Produit",
      offerQuantity: "Quantité",
      offerLocation: "Localisation (ville/quartier requis)",
      offerDescription: "Description",
      offerDescriptionPh: "Précisions sur la demande (facultatif)",
      offerPublishNow: "Publier immédiatement (visible par les vendeurs)",
      offerByAdmin: "Créée par l'admin",
      violationsTab: "Anti-contact",
      violationsTitle: "Tentatives de partage de contact bloquées",
      violationsHint: "{n} tentative(s) bloquée(s) au total. Repérez les utilisateurs récidivistes.",
      noViolations: "Aucune tentative bloquée pour le moment.",
      violationsAttempts: "{n} tentative(s)",
      violationsLast: "Dernière",
      deleteOfferConfirmTitle: "Supprimer cette offre ?",
      deleteOfferConfirmDesc: "Cette action est irréversible. L'offre de l'acheteur et toutes les réponses des vendeurs seront supprimées.",
      block: "Bloquer",
      unblock: "Débloquer",
      blockedLabel: "Bloqué",
      blockedDone: "Compte bloqué.",
      unblockedDone: "Compte débloqué.",
      historyTab: "Historique",
      financeTab: "Finances",
      totalReceived: "Total reçu",
      commission: "Commission",
      toPayout: "À reverser",
      payoutsTitle: "Vendeurs à payer",
      toPay: "à payer",
      closeOrderBtn: "Clôturer",
      closed: "Clôturé",
      noFinance: "Aucune donnée financière.",
      searchPlaceholder: "Rechercher (nom, email, téléphone, ville)…",
      call: "Appeler",
      whatsapp: "WhatsApp",
      createdAt: "Créée le", toProcess: "À traiter", seller: "Vendeur", buyer: "Acheteur",
      approve: "Valider l'annonce",
      reject: "Refuser",
      suspend: "Suspendre",
      reactivate: "Réactiver",
      delete: "Supprimer",
      edit: "Modifier",
      listingApproved: "Annonce validée",
      listingRejected: "Annonce refusée",
      listingSuspended: "Annonce suspendue",
      listingReactivated: "Annonce réactivée",
      listingDeleted: "Annonce supprimée",
      listingsTab: "Annonces",
      noListings: "Aucune annonce.",
      statusPending: "En attente", statusActive: "En ligne", statusPaused: "Suspendue", statusRejected: "Refusée", statusSold: "Vendue",
      deleteListingTitle: "Supprimer cette annonce ?",
      deleteListingDesc: "Cette action est irréversible. L'annonce sera définitivement supprimée et le vendeur en sera informé.",
      documents: "Documents",
      noDocuments: "Aucun document fourni",
      phone: "Téléphone",
      quartier: "Quartier",
      nif: "NIF",
      noResults: "Aucun résultat.",
      noPendingSellers: "Aucun vendeur en attente.",
      noPendingListings: "Aucune annonce en attente.",
      noBuyers: "Aucun acheteur.",
      noHistory: "Aucune activité terminée.",
      profession: "Profession / Métier",
      activity: "Activité",
      specialty: "Spécialité",
      farm: "Exploitation",
      payout: "Versement",
      deleteProfile: "Supprimer le profil",
      deleteConfirmTitle: "Supprimer définitivement ce profil ?",
      deleteConfirmDesc: "Cette action est irréversible. Le profil et toutes ses données (annonces, échanges, demandes) seront supprimés définitivement.",
      profileDeleted: "Profil supprimé",
    },
    categories: {
      "poulet-de-chair": "Poulet de chair",
      "poulet-local": "Poulet local",
      "oeufs": "Œufs",
      "pintade": "Pintade",
      "canard": "Canard",
      "caille": "Caille",
    },
    states: { vivant: "Vivant", abattu: "Abattu", pieces: "Découpé (pièces)", "pret-a-cuire": "Prêt à cuire", na: "" },
    order: {
      myOrders: "Mes commandes", ordersReceived: "Commandes reçues", order: "Commande",
      currentOrders: "Commandes en cours", historyOrders: "Historique",
      quantity: "Quantité", total: "Total", status: "Statut", payment: "Paiement",
      orderNow: "Commander", orderTitle: "Passer commande", orderCreated: "Commande créée !",
      pay: "Payer", payTitle: "Payer la commande", method: "Moyen de paiement",
      mobileMoney: "Mobile Money", manualTransfer: "Virement / dépôt (preuve)",
      simulatedNote: "Paiement simulé pour la démo. L'intégration réelle (Paystack / Mobile Money) viendra dans une phase dédiée.",
      proofUpload: "Preuve de transfert", proofRequired: "Ajoutez une preuve de transfert",
      confirmPayment: "Confirmer le paiement", markShipped: "Marquer expédiée",
      confirmDelivery: "Confirmer la réception", cancel: "Annuler la commande",
      guarantee: "Garantie acheteur", guaranteeHeld: "Fonds sous garantie",
      guaranteeReleased: "Garantie libérée au vendeur", timeline: "Suivi",
      noOrders: "Aucune commande pour le moment.", buyer: "Acheteur", seller: "Vendeur",
      view: "Voir la commande", paid: "Payée",
      statuses: { pending_seller: "En attente d'acceptation", pending_fee: "Frais de livraison en attente", pending_payment: "En attente de paiement", awaiting_validation: "Paiement en validation", paid: "Paiement reçu", preparing: "Prise en charge", shipped: "Livraison en cours", handed_over: "Commande livrée", delivered: "Livré et conforme", closed: "Clôturé", refused: "Refusée par le vendeur", cancelled: "Annulée", disputed: "Retour / arbitrage", refunded: "Remboursée" },
      acceptOrder: "Accepter la commande", refuseOrder: "Refuser", refuseTitle: "Motif du refus",
      motifDistance: "Trop loin (distance)", motifQuantite: "Quantité insuffisante", motifRupture: "Rupture de stock", motifAutre: "Autre",
      seeOtherSellers: "Voir d'autres vendeurs", awaitingSellerNote: "En attente de l'acceptation du vendeur (sous 2h).",
      payVia: "Payer via Orange Money", omNumber: "Numéro Orange Money", copy: "Copier", copied: "Numéro copié", amountToSend: "Montant exact à envoyer", paidBtn: "J'ai effectué le paiement",
      markPreparing: "Confirmer la prise en charge", markShippedNew2: "Livraison en cours (remis au livreur)", closeOrder: "Clôturer (autoriser le paiement)",
      netToReceive: "Montant net à recevoir",
      paymentStatuses: { unpaid: "Non payé", paid: "Payé", proof_submitted: "Reçu envoyé", released: "Fonds libérés", refunded: "Remboursé" },
      deliveryFee: "Frais de livraison", deliveryPending: "En attente : le vendeur fixe les frais de livraison.",
      deliveryHoursLabel: "Horaires de livraison", ordersAround: "Commandez 24h/24",
      payReceiptNote: "Paiement manuel : effectuez le dépôt puis envoyez la photo du reçu. Ovolaay Hub valide la réception des fonds (séquestre).",
      uploadReceipt: "Envoyer le reçu (photo)", receiptAdded: "Reçu ajouté",
      takePhoto: "Prendre une photo", fromGallery: "Galerie / fichiers", proofFormats: "JPG, PNG ou PDF",
      proofBadFormat: "Format non supporté. Utilisez JPG, PNG ou PDF.",
      downloadReceipt: "Télécharger le reçu (PDF)", receiptError: "Reçu indisponible pour le moment.",
      awaitingValidationNote: "Reçu reçu. Ovolaay Hub valide votre paiement, puis le vendeur organise la livraison.",
      validateReception: "Valider la réception", conforme: "Conforme", nonConforme: "Non conforme",
      trackTitle: "Suivi de la commande",
      stepPrepShort: "Préparation", stepMotoShort: "En route", stepTransitShort: "En transit", stepDeliveredShort: "Livrée",
      stepReceivedShort: "Reçue", stepConformeShort: "Conforme", stepClosedShort: "Terminée",
      sellerPrepareBtn: "Je prépare le colis", sellerShipBtn: "C'est parti, en route", sellerDeliveredBtn: "Colis remis à l'acheteur",
      sellerWaitBuyer: "En attente : l'acheteur confirme la réception.",
      buyerReceivedBtn: "J'ai reçu mon colis",
      warnTitle: "Attention", warnBody: "Une fois validé, il n'y a plus de retour en arrière. Vérifiez bien votre commande avant de confirmer.",
      warnContinue: "J'ai vérifié, continuer", warnCancel: "Annuler",
      chooseTitle: "Votre commande est-elle en ordre ?",
      confirmConformeBtn: "Tout est bon", confirmProblemBtn: "Il y a un problème",
      addProblemPhoto: "Ajouter une photo", problemPhotoHint: "Une photo du problème aide l'administrateur à trancher (optionnel).",
      conformeHint: "La commande est conforme → les fonds sont libérés au vendeur.",
      nonConformeTitle: "Signaler un problème", motif: "Motif du retour", motifPlaceholder: "Décrivez ce qui ne va pas (obligatoire)…",
      motifRequired: "Le motif est obligatoire.",
      buyerContact: "Coordonnées de l'acheteur", contactLocked: "Le numéro de l'acheteur sera débloqué après validation du paiement.",
      deliveryAddress: "Adresse de livraison", quartier: "Quartier", deliveryNote: "Repères / indications",
      addressHint: "Pré-rempli depuis votre profil — modifiable pour cette commande.",
      addressRequired: "Veuillez indiquer l'adresse de livraison.",
      addressForFee: "Adresse utilisée par le vendeur pour calculer les frais de livraison.",
      sellerOrganizes: "Vous organisez votre livreur. Contactez l'acheteur pour convenir de la livraison.",
      markShippedNew: "Confirmer la livraison en cours",
    },
    review: {
      leaveReview: "Laisser un avis", yourRating: "Votre note", comment: "Commentaire",
      submit: "Publier l'avis", verified: "Achat vérifié", noReviews: "Aucun avis pour le moment.",
      reviews: "avis", rating: "Note", thanks: "Merci pour votre avis !", reviewed: "Déjà évalué",
    },
    request: {
      myRequests: "Mes demandes d'achat", create: "Nouvelle demande", createTitle: "Publier une demande d'achat",
      maxPrice: "Prix maximum", neededBy: "Besoin avant le", note: "Précisions",
      submit: "Publier la demande", matchesFound: "vendeur(s) correspondant(s) trouvé(s)",
      noRequests: "Aucune demande pour le moment.", close: "Clôturer", open: "Ouverte", closed: "Clôturée",
      sellerTitle: "Demandes d'achat", sellerSubtitle: "Les acheteurs qui recherchent vos volailles.",
      viewMatches: "Voir les vendeurs correspondants", matchingListings: "Annonces correspondantes",
      noMatches: "Aucune annonce ne correspond pour l'instant.", deliveryNeeded: "Livraison souhaitée",
    },
    notif: { title: "Notifications", empty: "Aucune notification.", markAllRead: "Tout marquer comme lu" },
    badge: { bronze: "Bronze", silver: "Argent", gold: "Or", premium: "Premium RST", trusted: "Vendeur de confiance", none: "" },
    dispute: {
      open: "Ouvrir un litige", openTitle: "Ouvrir un litige", reason: "Motif du litige",
      reasonPlaceholder: "Décrivez le problème (produit non conforme, non livré…).",
      escalate: "Escalader à l'administrateur", escalated: "Escaladé — arbitrage RST",
      thread: "Discussion du litige", send: "Envoyer", status: "Statut du litige",
      title: "Litige", resolvedRefund: "Résolu — remboursé", resolvedRelease: "Résolu — en faveur du vendeur",
      openState: "Ouvert", refund: "Rembourser l'acheteur", release: "Libérer au vendeur",
      resolve: "Trancher le litige", submit: "Ouvrir le litige",
      openedAt: "Ouvert le", resolvedAt: "Clôturé le",
    },
    trusted: { title: "Vendeurs de confiance", subtitle: "Nos vendeurs vérifiés les mieux notés — et de nouveaux talents à découvrir.", listings: "annonce(s)" },

    rst: {
      tab: "Score RST",
      dashTitle: "Tableau de bord RST",
      dashSubtitle: "Indicateurs de confiance de la plateforme (données simulées).",
      configTitle: "Règles du Score de Confiance RST",
      configSubtitle: "Modifiez les pondérations et les paliers sans toucher au code. Enregistrer recalcule tous les scores.",
      totalOrders: "Commandes totales",
      delivered: "Commandes livrées",
      disputes: "Litiges",
      disputeRate: "Taux de litiges",
      refunds: "Remboursements",
      refundRate: "Taux de remboursement",
      avgResolution: "Délai moyen de traitement",
      hours: "h",
      revenue: "CA simulé",
      ordersByStatus: "Commandes par statut",
      topSellers: "Top vendeurs",
      score: "Score",
      tier: "Palier",
      deliveredCol: "Livrées",
      disputesCol: "Litiges",
      ratingCol: "Note",
      sellerRules: "Vendeurs",
      buyerRules: "Acheteurs",
      weights: "Pondérations (points)",
      tiers: "Paliers",
      tierName: "Nom du palier",
      tierMin: "Score minimum",
      addTier: "Ajouter un palier",
      removeTier: "Retirer",
      save: "Enregistrer et recalculer",
      saved: "Règles enregistrées — scores recalculés",
      reset: "Valeurs par défaut",
      myScore: "Mon Score de Confiance RST",
      scoreHint: "Concluez vos transactions sur la plateforme pour faire monter votre score et débloquer des avantages.",
      loyaltyReplaced: "Ce score remplace un simple programme de points. Il valorise la fiabilité et prépare des avantages, une meilleure visibilité et des conditions préférentielles.",
      fields: {
        points_per_delivered: "Points par commande livrée",
        points_per_review: "Points par avis reçu",
        points_per_rating_point: "Points par point de note (× note moyenne)",
        points_per_1000_volume: "Points par 1000 FCFA livrés",
        points_per_month_seniority: "Points par mois d'ancienneté",
        dispute_penalty: "Pénalité par litige",
        points_per_completed_order: "Points par commande honorée",
        points_per_payment: "Points par paiement correct",
      },
    },

    perks: {
      title: "Avantages",
      badge: "Badge de confiance visible",
      visibility: "Meilleure visibilité",
      free_ads: "Publicité gratuite",
      advanced_stats: "Statistiques avancées",
      priority_support: "Support prioritaire",
      priority_features: "Accès prioritaire aux fonctionnalités",
      note: "Ces avantages récompensent la fiabilité. Ils n'accordent jamais automatiquement la première place : le classement privilégie toujours la confiance et la qualité de service.",
    },
    progress: {
      view: "Mon évolution",
      title: "Mon évolution",
      subtitle: "Suivez votre progression, vos indicateurs et vos avantages RST.",
      currentTier: "Palier actuel",
      nextTier: "Prochain palier",
      maxTier: "Palier maximum atteint",
      progressLabel: "Progression vers {tier}",
      pointsToNext: "{n} points restants",
      myPerks: "Mes avantages",
      noPerks: "Aucun avantage pour ce palier — progressez pour en débloquer.",
      allTiers: "Paliers et avantages",
      metrics: "Mes indicateurs",
      delivered: "Commandes livrées",
      totalOrders: "Commandes totales",
      successRate: "Taux de réussite",
      responseRate: "Taux de réponse",
      rating: "Réputation",
      disputes: "Litiges",
      disputeRate: "Taux de litiges",
      revenue: "Ventes (CA simulé)",
      spend: "Achats (simulé)",
      paidOrders: "Paiements honorés",
      salesEvolution: "Évolution des ventes (6 mois)",
      purchasesEvolution: "Évolution des achats (6 mois)",
      reputationEvolution: "Évolution de la réputation (6 mois)",
      nextBadge: "Prochain badge",
      badgeGoals: "Objectifs pour le badge {badge}",
      needDeliveries: "Encore {n} commande(s) livrée(s)",
      needRating: "Note moyenne ≥ {r}",
      needLowDisputes: "Peu de litiges",
      simulator: "Objectifs à atteindre",
      count: "cmd",
      rewardsTitle: "Historique des récompenses",
      rewardsSubtitle: "Vos points RST gagnés (missions et paliers).",
      rewardMission: "Mission accomplie",
      rewardTier: "Nouveau palier",
      rewardsEmpty: "Aucune récompense pour le moment — accomplissez une mission pour commencer.",
    },
    hint: {
      orders_to_tier: "Encore {n} commande(s) réussie(s) pour atteindre le palier {tier}.",
      deliveries_for_badge: "Encore {n} commande(s) livrée(s) pour obtenir le badge {badge}.",
      rating_for_badge: "Maintenez une note ≥ {r} pour obtenir le badge {badge}.",
      respond_faster: "Répondez plus rapidement aux acheteurs pour améliorer votre visibilité.",
      keep_going: "Continuez ainsi — vos bonnes pratiques renforcent votre confiance RST.",
    },

    seller: { profile: "Profil vendeur", listings: "Annonces", reputation: "Réputation", contactHidden: "Les coordonnées restent masquées — échangez via la plateforme." },

    missions: {
      title: "Missions & objectifs",
      subtitle: "Accomplissez des missions pour gagner des points RST bonus.",
      adminTitle: "Missions & objectifs",
      adminSubtitle: "Activez les missions et réglez les points bonus. Enregistrer recalcule tous les scores.",
      enabled: "Activée",
      bonus: "Points bonus",
      target: "Objectif",
      bonusPts: "+{n} pts RST",
      completed: "Accompli",
      blocked: "En attente (litige à résoudre)",
      sellerLabel: "Vendeurs",
      buyerLabel: "Acheteurs",
      labels: {
        deliver_3: "Livrer 3 commandes",
        reviews_5: "Obtenir 5 avis",
        response_80: "Taux de réponse ≥ 80%",
        no_dispute_10: "10 commandes livrées sans litige",
        honor_3: "Honorer 3 commandes",
        reviews_3: "Laisser 3 avis vérifiés",
        complete_profile: "Compléter mon profil (téléphone + ville)",
      },
    },

    market: {
      title: "Centre de Pilotage",
      subtitle: "Votre tableau de bord du marché avicole — mis à jour en continu.",
      simulated: "Données simulées",
      avgPrices: "Prix moyens par catégorie",
      priceTrend: "Évolution des prix",
      activity: "Activité",
      activityCurve: "Activité avicole",
      trend: "Tendance",
      activityHint: "Volume de commandes et tendances du marché (indicatif).",
      offers: "Offres publiées",
      requests: "Demandes publiées",
      transactions: "Transactions",
      volume: "Volume échangé",
      highDemand: "Régions en forte demande",
      deficit: "Régions en déficit",
      topCategories: "Catégories les plus recherchées",
      opportunities: "Opportunités du jour",
      journal: "Journal du marché",
      morning: "Matin",
      evening: "Soir",
      tip: "Conseil du jour",
      noData: "Pas encore de données",
    },
    advantages: {
      title: "Pourquoi Ovolaay Hub ?",
      subtitle: "Des avantages concrets pour acheter et vendre en confiance.",
      buyers: "Pour les acheteurs",
      sellers: "Pour les vendeurs",
      b1: "Protection Achat",
      b2: "Professionnels vérifiés",
      b3: "Gain de temps",
      b4: "Historique des achats",
      b5: "Assistance",
      b6: "Suivi des commandes",
      b7: "Fournisseurs fiables",
      s1: "Nouveaux clients",
      s2: "Réputation",
      s3: "Visibilité",
      s4: "Publicité gratuite selon le niveau",
      s5: "Statistiques",
      s6: "Accompagnement",
      s7: "Développement de l'activité",
    },
    future: {
      title: "Bientôt sur Ovolaay Hub",
      subtitle: "De nouveaux outils pour piloter toute votre activité.",
      soon: "Bientôt",
      bandes: "Suivi des bandes",
      bandesDesc: "Suivez vos bandes (J1→J45), pesées, vaccins et rappels automatiques.",
      partners: "Partenaires financiers",
      partnersDesc: "Accédez à des solutions de financement adaptées.",
      club: "Club Ovolaay Hub",
      clubDesc: "Avantages et communauté des professionnels.",
      coach: "Coach professionnel",
      coachDesc: "Un accompagnement pour développer votre exploitation.",
      stats: "Statistiques avancées",
      statsDesc: "Analyses détaillées de votre activité.",
      services: "Services partenaires",
      servicesDesc: "Produits et services utiles à la filière.",
    },
    profile: {
      activityType: "Type d'activité",
      sellerAccount: "Compte vendeur",
      buyerAccount: "Compte acheteur",
      verified: "Vérifié",
      farmName: "Nom de la ferme",
      email: "Adresse email",
      phone: "Téléphone",
      location: "Localisation",
      activity: "Activité",
      payout: "Mode de versement",
      profession: "Profession / Métier (facultatif)",
      professionPlaceholder: "Ex. Restaurateur, revendeur, cuisinier…",
      farmType: "Type d'exploitation",
      species: "Espèces élevées",
      farmSize: "Taille de l'exploitation",
      save: "Enregistrer mon profil",
      saved: "Profil mis à jour",
    },
    verify: {
      status: "Statut du compte",
      toVerify: "À vérifier",
      verified: "Vérifié",
      notice: "Votre compte est en cours de vérification. Certaines actions restent limitées jusqu'à validation par l'équipe Ovolaay Hub.",
      sendDocs: "Envoyez vos justificatifs (NIF, documents professionnels) à l'équipe Ovolaay Hub :",
      private: "Ces informations ne sont jamais publiques.",
      whatsapp: "WhatsApp officiel",
      email: "E-mail",
      nifLabel: "NIF (optionnel)",
      docTitle: "Vérification (optionnel)",
      docHint: "Ajoutez une pièce d'identité ou un NIF. Optionnel et strictement privé.",
      viaWhatsapp: "Envoi possible via WhatsApp",
      addDoc: "Ajouter un document",
    },
    protection: {
      title: "Protection Achat Ovolaay Hub",
      amount: "Montant de la commande",
      fee: "Protection Achat Ovolaay Hub",
      total: "Total à payer",
      note: "Frais du moyen de paiement à la charge de l'acheteur. Aucun paiement en espèces.",
      adminTitle: "Protection Achat (paramètres)",
      adminSubtitle: "Calcul interne, jamais affiché en pourcentage. Modifiable ici.",
      tier1Max: "Seuil (FCFA)",
      tier1Rate: "Taux interne (0–1) sous le seuil",
      tier2Cap: "Plafond au-dessus du seuil (FCFA)",
    },
  },
  en: {
    nav: {
      home: "Home", catalogue: "Catalogue", sell: "Sell my poultry",
      myListings: "My available poultry", messages: "Messages", dashboard: "Dashboard", profile: "My profile",
      admin: "Administration", login: "Log in", register: "Sign up", logout: "Log out", browse: "Browse",
      market: "Market", publish: "Post", activity: "Activity", myspace: "My space", offers: "Offers",
    },
    publish: {
      stepOf: "Step {n} of {total}",
      steps: { product: "Product", photo: "Photo", quantity: "Quantity", price: "Price", place: "Location", publish: "Publish" },
      photoHint: "Add one or more clear photos of your product (optional but recommended).",
      reviewHint: "Review the details before publishing.",
      publishNow: "Publish now",
    },
    space: {
      salesBoard: "My sales",
      ordersBoard: "My purchases",
      ordersReceived: "Orders received",
      delivered: "Delivered",
      refused: "Refused",
      revenue: "Revenue",
      spend: "Total spent",
      inProgress: "In progress",
      myPurchases: "My purchases",
      myListings: "My listings",
      myListingsDesc: "{n} active listing(s)",
      mySales: "My sales",
      mySalesDesc: "Orders received, delivered, revenue",
      myPurchasesDesc: "Track your current and past orders",
      myOffersDesc: "Post your need and receive offers",
      reputation: "Reputation",
      reputationDesc: "Score, badges and progress",
      profile: "Profile",
      profileDesc: "Your personal information",
      settings: "Settings",
      settingsDesc: "Payout methods, language, log out",
      language: "Language",
    },
    push: {
      title: "Notifications",
      descOn: "You receive order, offer and message alerts on this device.",
      descOff: "Turn on notifications so you never miss anything on this device.",
      descDenied: "Notifications are blocked. Allow them in your browser or phone settings, then try again.",
      descUnsupported: "Your browser does not support notifications.",
      statusOn: "Enabled",
      statusOff: "To allow",
      statusDenied: "Blocked",
      enable: "Enable notifications",
      disable: "Disable",
      enabling: "Enabling…",
      enableFailed: "Could not enable notifications. Check your permissions.",
      enabledOk: "Notifications enabled on this device.",
      disabledOk: "Notifications disabled on this device.",
      remindTitle: "Turn on notifications",
      remindDesc: "Get alerted about your orders, offers and messages, even when the app is closed.",
      remindLater: "Later",
    },
    offers: {
      title: "Offers", buyerSubtitle: "Post your need, get quotes from sellers, pick the best one.",
      sellerSubtitle: "Answer buyers' requests with your price and availability.",
      buyerEmptyTitle: "You have no active offer",
      buyerEmptyText: "Describe what you're looking for (product, quantity, commune, date). After approval, sellers will send you quotes.",
      create: "Create an offer", createTitle: "New purchase offer",
      createSubtitle: "Fill in your need. Admin approves before it's shown to sellers.",
      product: "Product wanted", quantity: "Quantity", deliveryCommune: "Delivery commune", deliveryLocation: "Delivery location", neighborhoodRequired: "Please enter the delivery town / neighborhood.",
      neededBy: "Wanted by", note: "Comment (optional)", notePlaceholder: "E.g. morning delivery, live poultry…",
      createdAt: "Created on", updatedAt: "Updated on",
      submit: "Submit request", created: "Offer submitted. Awaiting admin approval.",
      communeRequired: "Please choose the delivery commune.",
      statusPending: "Awaiting approval", statusPublished: "Published", statusSuspended: "Suspended", statusPaused: "Paused",
      pendingNote: "Your offer is awaiting admin approval. You'll be notified once published.",
      suspendedNote: "Your offer was suspended by the administration.",
      pausedNote: "Your offer is paused: sellers can no longer see it.",
      resume: "Resume", pause: "Pause", cancelOffer: "Delete offer", deleteConfirmTitle: "Delete this offer?", deleteConfirmDesc: "This action is irreversible. Your offer and seller responses will be deleted.", deleted: "Offer deleted.",
      intentExplain: "To view seller responses and start an order, confirm your purchase intent is serious.",
      confirmIntent: "I confirm my serious intent",
      responsesWaiting: "seller response(s) waiting for you", noResponsesYet: "No response yet.",
      sellerResponses: "Seller responses", chooseSeller: "Choose this seller",
      orderStarted: "Order started! The seller will set the delivery fee.",
      sellerEmpty: "No published offers right now. Check back later.",
      respond: "Respond", editResponse: "Edit my response", respondTitle: "Respond to this offer",
      yourPrice: "Your price (total)", unitPrice: "Unit price", total: "Total", availability: "Availability",
      availabilityPlaceholder: "E.g. available within 2 days, delivery possible…",
      sendResponse: "Send my response", responseSent: "Response sent to the buyer.",
      respRequired: "Enter a price and your availability.", youProposed: "Your offer", responsesLabel: "response(s)",
      counterCta: "Propose my price", counterTitle: "Propose my price",
      counterDesc: "Propose your unit price to the seller. They can accept or decline it.",
      yourCounterPrice: "Your proposed unit price", counterSend: "Send my proposal",
      counterInvalid: "Enter a valid price.", counterSent: "Proposal sent to the seller.",
      counterPending: "Counter-offer sent ({p} / unit) — awaiting the seller's reply.",
      counterAccepted: "The seller accepted your price. You can finalize.",
      counterRejected: "The seller declined your price. Their original price still stands.",
      counterReceived: "Buyer counter-offer: {p} / unit", counterVsYours: "Your original price: {p} / unit",
      accept: "Accept", reject: "Decline",
      counterAcceptedSeller: "Counter-offer accepted. The new price is applied.",
      counterRejectedSeller: "Counter-offer declined.",
      noPhoneWarning: "Do not share any phone number: contact details are exchanged only after payment confirmation.",
    },
    common: {
      loading: "Loading…", seeAll: "See all", search: "Search", reset: "Reset", cancel: "Cancel", validate: "Validate",
      save: "Save", publish: "Publish", edit: "Edit", delete: "Delete", back: "Back", send: "Send",
      from: "from", demo: "Demo", verified: "Verified", pending: "Pending", required: "This field is required", community: "Join the Community",
    },
    hero: {
      badge: "Mali", searchPlaceholder: "e.g. chicken, eggs, guinea fowl…",
      trust1: "Verified sellers", trust2: "Local delivery", trust3: "Across Mali", ctaSignup: "Sign up — it's free", ctaLogin: "Already registered? Log in",
    },
    home: {
      categoriesTitle: "Browse by category", categoriesSubtitle: "Choose the poultry you are looking for.",
      value1Title: "Trust first", value1Text: "Chat via internal messaging; reputation and tracking stay on the platform.",
      value2Title: "Proximity", value2Text: "Buy from verified farmers near you.",
      value3Title: "Local quality", value3Text: "Healthy poultry: local chicken, guinea fowl, duck, quail.",
      popularTitle: "Recent availabilities", popularSubtitle: "The latest poultry posted by our sellers.",
      seeCatalogue: "View catalogue", trustedTitle: "Trusted sellers",
      latestTitle: "Latest products", latestSubtitle: "Chickens and eggs recently posted near you.",
      risingTitle: "Fast-rising seller", risingGain: "+{n} pts this month", risingCta: "View profile",
    },
    catalog: {
      title: "Poultry catalogue", subtitle: "Browse availabilities posted by verified sellers.",
      resultsFor: "Results for", searchPlaceholder: "Search a product (broiler, eggs, quail…)", filters: "Filters",
      location: "City / neighborhood / commune", locationPlaceholder: "e.g. Bamako, Commune I, Badalabougou…",
      category: "Category", region: "Region", state: "State", maxPrice: "Maximum price",
      deliveryOnly: "Delivery available only", allRegions: "All regions", allStates: "All states",
      sortRecent: "Most recent", sortRecommended: "Recommended", sortPriceAsc: "Price: low to high", sortPriceDesc: "Price: high to low",
      results: "result(s)", emptyTitle: "No poultry found", emptyText: "Try adjusting your filters or search.",
    },
    listing: {
      quantity: "Available quantity", avgWeight: "Average weight", region: "Region / city",
      availableFrom: "Available from", delivery: "Delivery", deliveryYes: "Delivery available",
      deliveryNo: "Pickup only", seller: "Seller", exchange: "Message",
      exchangeHint: "Personal contact details stay hidden. Chat safely through the platform's internal messaging.",
      continueBrowsing: "Keep browsing", relatedTitle: "In the same category", soldOut: "Sold out",
      paused: "Paused", loginToExchange: "Log in as a buyer to message the seller.",
      exchangeStarted: "Message sent! Find the conversation in \"Messages\".",
    },
    auth: {
      loginTitle: "Log in", loginSubtitle: "Access your Ovolaay Hub space.",
      registerTitle: "Sign up", registerSubtitle: "Join the poultry marketplace.",
      name: "Full name / Farm name", email: "Email", password: "Password", confirmPassword: "Confirm password", passwordMismatch: "Passwords do not match.", role: "I am a…",
      roleBuyer: "Buyer", roleSeller: "Seller", region: "Region", city: "City",
      phone: "Phone number", phoneHint: "Required — will stay private (never shown publicly).",
      chooseRole: "What do you want to do?", iSell: "I sell", iBuy: "I buy",
      iSellHint: "Farmer / seller", iBuyHint: "Buy products",
      specialty: "What do you sell?", specMultiHint: "Select every product you sell (you can pick several).", specRequired: "Please select at least one product you sell.", specPoulet: "Chickens", specOeufs: "Eggs", specDeux: "Both",
      selectRegion: "Region / District", selectDistrict: "Commune / Cercle", selectCity: "Commune (optional)", quartier: "Town / Neighborhood", quartierHint: "Free text (addresses are not postal in Mali).",
      loginBtn: "Log in", registerBtn: "Create my account", noAccount: "No account yet?",
      identifier: "Email or phone", emailOptional: "Email (optional)", emailOptionalHint: "No email? No problem, your phone is enough.",
      forgotPassword: "Forgot password?", forgotTitle: "Reset your password", forgotSubtitle: "Get a code by email or via WhatsApp.",
      sendCode: "Send code", codeSent: "If an account exists, a code was generated.",
      codeSentHint: "Enter the code received (email) or given by WhatsApp support, then your new password.",
      code: "Reset code", newPassword: "New password", resetBtn: "Reset", resetDone: "Password reset. Please log in.", linkSent: "Email sent! Check your inbox.", linkSentHint: "A secure reset link was just sent to your email. It expires in 1 hour. Open it from your inbox to choose a new password.", resetTitle: "Choose a new password", resetSubtitle: "Enter your new password.", resetNoToken: "Reset link missing or invalid. Please request a new one.",
      noCodeWhatsapp: "No code received? Contact WhatsApp support",
      hasAccount: "Already have an account?",
      sellerNote: "Your seller account will be activated after an administrator verification.",
    },
    dashboard: {
      welcome: "Hello", sellerTitle: "My available poultry", sellerSubtitle: "Post and manage your availabilities.",
      addListing: "Add an availability", noListings: "You haven't posted any poultry yet.",
      notVerifiedTitle: "Account pending verification",
      notVerifiedText: "An administrator must approve your seller account before you can post poultry.",
      buyerTitle: "My buyer space", buyerSubtitle: "Find your conversations with sellers.",
      active: "Active", pause: "Pause", activate: "Reactivate",
    },
    listingForm: {
      title: "Post poultry", editTitle: "Edit poultry", category: "Poultry type", state: "State",
      quantity: "Quantity", avgWeight: "Average weight (e.g. 1.8 kg)", price: "Price", priceUnit: "Price unit",
      region: "Region", city: "City", availabilityDate: "Availability date", delivery: "Delivery available",
      photos: "Photos", addPhotos: "Add photos", comment: "Comment",
      commentPlaceholder: "Describe your poultry (feed, farming, conditions…).",
      voiceSoon: "Voice comment is coming in a future version.",
      published: "Poultry posted successfully!", updated: "Availability updated.",
      updatedRevalidate: "Listing edited — pending validation again.",
      revalidateNote: "Any change sends the listing back to Ovolaay Hub for validation before it is published again.",
      takePhoto: "Take a photo", chooseCategory: "What are you selling?",
      plateaux: "Number of trays (30 eggs)", perPlateau: "per tray",
    },
    messages: {
      title: "My messages", empty: "No conversations yet.",
      selectConversation: "Select a conversation to view messages.", placeholder: "Write your message…",
      about: "About", you: "You",
      loadError: "Could not load conversations.",
      sendError: "Failed to send. Please retry.",
      attachError: "Failed to add the image.",
      warnPhone: "Warning: do not complete sales off-platform. Ovolaay accepts no liability in case of fraud. Close your deals on the platform.",
      makeOffer: "Make an offer", offerTitle: "Make an offer",
      offerAmount: "Total amount offered (FCFA)", offerQuantity: "Quantity",
      sendOffer: "Send offer", offerSent: "Offer sent", offerLabel: "Offer",
      offerFor: "for {q} unit(s)", accept: "Accept", reject: "Decline",
      offerPending: "Awaiting response", offerAccepted: "Offer accepted",
      offerRejected: "Offer declined", offerExpired: "Offer expired",
      offerExpiresHint: "Expires within 1 hour", offerAcceptedToast: "Offer accepted — order created",
      offerRejectedToast: "Offer declined", offerError: "Cannot act on this offer.",
      viewOrder: "View order", payNow: "Pay order", download: "Download", yourOffer: "Your offer",
      expiresInLabel: "Time left:", payBeforeExpiry: "Pay before it expires",
      offerAcceptedPinned: "Offer accepted — order created",
      offerAcceptedInfo: "Offer accepted! The seller will set the delivery fee, then you can pay.",
      feePending: "Awaiting the seller's delivery fee",
    },
    admin: {
      title: "Administration", subtitle: "Manage accounts, sellers and listings.",
      viewProfile: "View profile",
      registeredAt: "Registered on",
      profileBuyerTitle: "Buyer profile",
      profileSellerTitle: "Seller profile",
      profileLoading: "Loading profile…",
      profileContact: "Contact details (admin only)",
      profileKpiOrders: "Orders",
      profileKpiFinalized: "Finalized",
      profileKpiRevenue: "Revenue",
      profileKpiSpend: "Total spent",
      profileListings: "Published listings",
      profileNoListings: "No listings published.",
      profileOrdersSeller: "Sales history",
      profileOrdersBuyer: "Purchase history",
      profileNoOrders: "No orders yet.",
      profilePublishedOn: "Published on",
      profileSoldOn: "Sold on",
      profileOnlineSince: "Online for {n}d",
      profileLongOnline: "Unsold for {n}d",
      profileDateCreated: "Order",
      profileDatePaid: "Paid",
      profileDateShipped: "Shipped",
      profileDateDelivered: "Delivered",
      profileDateClosed: "Closed",
      buyers: "Buyers", sellers: "Sellers", pending: "Pending sellers", listings: "Listings",
      conversations: "Conversations", today: "Today", newRegistrations: "sign-ups", newOrders: "orders", users: "Users", sellersTab: "Sellers", listingsTab: "Listings", disputesTab: "Disputes", ordersTab: "Orders", setFee: "Delivery fee", setFeeBtn: "Set fee", validatePayment: "Validate payment", viewReceipt: "View receipt", awaitingFee: "Fee to set", awaitingValidation: "Receipt to validate", feeSaved: "Fee saved", paymentValidated: "Payment validated — contact unlocked", noOrders: "No orders to process.", rstTab: "RST Score",
      resolveRefund: "Refund buyer", resolveRelease: "Release to seller",
      noDisputes: "No disputes yet.",
      disputeDefaultTitle: "Admin auto-added to new disputes",
      disputeDefaultHint: "This admin automatically joins every new dispute and can read and write in it.",
      disputeDefaultPlaceholder: "Choose an admin",
      disputeDefaultSaved: "Default admin saved",
      disputeAssigned: "Admin in charge",
      disputeUnassigned: "None",
      disputeOpenConvo: "Open conversation",
      disputeTransferPlaceholder: "Transfer to…",
      disputeTransferred: "Dispute transferred",
      disputeMsgPlaceholder: "Write a message…",
      disputeSend: "Send",
      makePremium: "Make Premium RST", removePremium: "Remove Premium",
      verify: "Verify", unverify: "Remove verification", verified: "Verified ✅ the seller can post",
      sellerVerified: "Verified seller", sellerUnverified: "Unverified seller",
      pendingSellersTab: "Pending sellers", verifiedSellersTab: "Verified sellers", noPendingSellers: "No seller awaiting validation.", noVerifiedSellers: "No verified seller.", pendingListingsTab: "Pending listings", buyersTab: "Buyers", offersTab: "Offers", noOffers: "No offers yet.", offerPublish: "Publish", offerSuspend: "Suspend", offerPause: "Pause", offerUpdated: "Offer updated.", offerDeleted: "Offer deleted.", offerCreate: "Create offer", offerSaveEdit: "Save", offerEditTitle: "Edit purchase offer", offerEditDesc: "Update the product, quantity, location, description and status.", offerUpdated: "Offer updated.", optional: "optional", offerBuyerOrName: "Select a buyer or enter an external buyer name.", offerExternalBuyer: "External buyer (not registered)", offerExternalBuyerPh: "Buyer name", offerExternalTag: "External buyer", offerStatus: "Status", offerCreated: "Offer created successfully.", offerCreateTitle: "Create an offer on behalf of a buyer", offerCreateDesc: "Set the product, quantity, location and a description. The offer will appear in the same space as buyers' offers.", offersManageHint: "Create, publish, suspend or delete purchase offers.", offerBuyer: "Buyer", offerPickBuyer: "Choose a buyer", offerPickProduct: "Choose a product", offerProduct: "Product", offerQuantity: "Quantity", offerLocation: "Location (city/neighborhood required)", offerDescription: "Description", offerDescriptionPh: "Details about the request (optional)", offerPublishNow: "Publish immediately (visible to sellers)", offerByAdmin: "Created by admin", violationsTab: "Anti-contact", violationsTitle: "Blocked contact-sharing attempts", violationsHint: "{n} blocked attempt(s) in total. Spot repeat offenders.", noViolations: "No blocked attempts yet.", violationsAttempts: "{n} attempt(s)", violationsLast: "Last", deleteOfferConfirmTitle: "Delete this offer?", deleteOfferConfirmDesc: "This action is irreversible. The buyer's offer and all seller responses will be deleted.", block: "Block", unblock: "Unblock", blockedLabel: "Blocked", blockedDone: "Account blocked.", unblockedDone: "Account unblocked.", historyTab: "History",
      financeTab: "Finances", totalReceived: "Total received", commission: "Commission", toPayout: "To pay out", payoutsTitle: "Sellers to pay", toPay: "to pay", closeOrderBtn: "Close", closed: "Closed", noFinance: "No financial data.",
      searchPlaceholder: "Search (name, email, phone, city)…", call: "Call", whatsapp: "WhatsApp",
      createdAt: "Created on", toProcess: "To process", seller: "Seller", buyer: "Buyer",
      approve: "Approve listing", reject: "Reject", listingApproved: "Listing approved", listingRejected: "Listing rejected",
      suspend: "Suspend", reactivate: "Reactivate", delete: "Delete", edit: "Edit",
      listingSuspended: "Listing suspended", listingReactivated: "Listing reactivated", listingDeleted: "Listing deleted",
      listingsTab: "Listings", noListings: "No listings.",
      statusPending: "Pending", statusActive: "Live", statusPaused: "Suspended", statusRejected: "Rejected", statusSold: "Sold",
      deleteListingTitle: "Delete this listing?", deleteListingDesc: "This action is irreversible. The listing will be permanently deleted and the seller notified.",
      documents: "Documents", noDocuments: "No document provided", phone: "Phone", quartier: "Neighborhood", nif: "Tax ID", noResults: "No results.",
      noPendingSellers: "No pending sellers.", noPendingListings: "No pending listings.", noBuyers: "No buyers.", noHistory: "No completed activity.",
      profession: "Profession / Job", activity: "Activity", specialty: "Specialty", farm: "Farm", payout: "Payout",
      deleteProfile: "Delete profile", deleteConfirmTitle: "Permanently delete this profile?",
      deleteConfirmDesc: "This action is irreversible. The profile and all its data (listings, chats, requests) will be permanently deleted.",
      profileDeleted: "Profile deleted",
    },
    categories: {
      "poulet-de-chair": "Broiler chicken", "poulet-local": "Local chicken",
      "oeufs": "Eggs",
      "pintade": "Guinea fowl", "canard": "Duck", "caille": "Quail",
    },
    states: { vivant: "Live", abattu: "Slaughtered", pieces: "Cut (pieces)", "pret-a-cuire": "Ready to cook", na: "" },
    order: {
      myOrders: "My orders", ordersReceived: "Orders received", order: "Order",
      currentOrders: "Current orders", historyOrders: "History",
      quantity: "Quantity", total: "Total", status: "Status", payment: "Payment",
      orderNow: "Order now", orderTitle: "Place order", orderCreated: "Order created!",
      pay: "Pay", payTitle: "Pay the order", method: "Payment method",
      mobileMoney: "Mobile Money", manualTransfer: "Transfer / deposit (proof)",
      simulatedNote: "Simulated payment for the demo. Real integration (Paystack / Mobile Money) will come in a dedicated phase.",
      proofUpload: "Transfer proof", proofRequired: "Please add a transfer proof",
      confirmPayment: "Confirm payment", markShipped: "Mark as shipped",
      confirmDelivery: "Confirm delivery", cancel: "Cancel order",
      guarantee: "Buyer guarantee", guaranteeHeld: "Funds held in guarantee",
      guaranteeReleased: "Guarantee released to seller", timeline: "Tracking",
      noOrders: "No orders yet.", buyer: "Buyer", seller: "Seller",
      view: "View order", paid: "Paid",
      statuses: { pending_seller: "Awaiting acceptance", pending_fee: "Awaiting delivery fee", pending_payment: "Awaiting payment", awaiting_validation: "Payment under review", paid: "Payment received", preparing: "Preparing", shipped: "Out for delivery", handed_over: "Delivered", delivered: "Delivered & conforming", closed: "Closed", refused: "Refused by seller", cancelled: "Cancelled", disputed: "Return / review", refunded: "Refunded" },
      acceptOrder: "Accept order", refuseOrder: "Refuse", refuseTitle: "Refusal reason", motifDistance: "Too far (distance)", motifQuantite: "Not enough quantity", motifRupture: "Out of stock", motifAutre: "Other", seeOtherSellers: "See other sellers", awaitingSellerNote: "Waiting for the seller to accept (within 2h).",
      payVia: "Pay via Orange Money", omNumber: "Orange Money number", copy: "Copy", copied: "Number copied", amountToSend: "Exact amount to send", paidBtn: "I have paid",
      markPreparing: "Confirm handling", markShippedNew2: "Out for delivery (given to courier)", closeOrder: "Close (authorize payout)", netToReceive: "Net amount to receive",
      paymentStatuses: { unpaid: "Unpaid", paid: "Paid", proof_submitted: "Receipt sent", released: "Funds released", refunded: "Refunded" },
      deliveryFee: "Delivery fee", deliveryPending: "Pending: the seller is setting the delivery fee.",
      deliveryHoursLabel: "Delivery hours", ordersAround: "Order 24/7",
      payReceiptNote: "Manual payment: make the deposit then send a photo of the receipt. Ovolaay Hub validates the funds (escrow).",
      uploadReceipt: "Send receipt (photo)", receiptAdded: "Receipt added",
      takePhoto: "Take a photo", fromGallery: "Gallery / files", proofFormats: "JPG, PNG or PDF",
      proofBadFormat: "Unsupported format. Use JPG, PNG or PDF.",
      downloadReceipt: "Download receipt (PDF)", receiptError: "Receipt not available yet.",
      awaitingValidationNote: "Receipt received. Ovolaay Hub is validating your payment, then the seller arranges delivery.",
      validateReception: "Validate reception", conforme: "Conforming", nonConforme: "Not conforming",
      trackTitle: "Order tracking",
      stepPrepShort: "Packing", stepMotoShort: "On the way", stepTransitShort: "In transit", stepDeliveredShort: "Delivered",
      stepReceivedShort: "Received", stepConformeShort: "Conforming", stepClosedShort: "Done",
      sellerPrepareBtn: "I'm packing the parcel", sellerShipBtn: "Off it goes, on the way", sellerDeliveredBtn: "Parcel handed to buyer",
      sellerWaitBuyer: "Waiting: the buyer confirms reception.",
      buyerReceivedBtn: "I received my parcel",
      warnTitle: "Careful", warnBody: "Once validated, there is no going back. Please check your order carefully before confirming.",
      warnContinue: "I checked, continue", warnCancel: "Cancel",
      chooseTitle: "Is your order all good?",
      confirmConformeBtn: "All good", confirmProblemBtn: "There's a problem",
      addProblemPhoto: "Add a photo", problemPhotoHint: "A photo of the issue helps the admin decide (optional).",
      conformeHint: "The order conforms → funds are released to the seller.",
      nonConformeTitle: "Report a problem", motif: "Return reason", motifPlaceholder: "Describe what is wrong (required)…",
      motifRequired: "A reason is required.",
      buyerContact: "Buyer contact", contactLocked: "The buyer's phone will be unlocked after payment validation.",
      deliveryAddress: "Delivery address", quartier: "Neighborhood", deliveryNote: "Landmarks / directions",
      addressHint: "Pre-filled from your profile — editable for this order.",
      addressRequired: "Please enter the delivery address.",
      addressForFee: "Address used by the seller to calculate the delivery fee.",
      sellerOrganizes: "You manage your own courier. Contact the buyer to arrange delivery.",
      markShippedNew: "Confirm delivery in progress",
    },
    review: {
      leaveReview: "Leave a review", yourRating: "Your rating", comment: "Comment",
      submit: "Post review", verified: "Verified purchase", noReviews: "No reviews yet.",
      reviews: "reviews", rating: "Rating", thanks: "Thanks for your review!", reviewed: "Already reviewed",
    },
    request: {
      myRequests: "My buying requests", create: "New request", createTitle: "Post a buying request",
      maxPrice: "Maximum price", neededBy: "Needed by", note: "Details",
      submit: "Post request", matchesFound: "matching seller(s) found",
      noRequests: "No requests yet.", close: "Close", open: "Open", closed: "Closed",
      sellerTitle: "Buying requests", sellerSubtitle: "Buyers looking for your poultry.",
      viewMatches: "View matching sellers", matchingListings: "Matching listings",
      noMatches: "No matching listings for now.", deliveryNeeded: "Delivery needed",
    },
    notif: { title: "Notifications", empty: "No notifications.", markAllRead: "Mark all as read" },
    badge: { bronze: "Bronze", silver: "Silver", gold: "Gold", premium: "Premium RST", trusted: "Trusted seller", none: "" },
    dispute: {
      open: "Open a dispute", openTitle: "Open a dispute", reason: "Dispute reason",
      reasonPlaceholder: "Describe the issue (item not as described, not delivered…).",
      escalate: "Escalate to admin", escalated: "Escalated — RST arbitration",
      thread: "Dispute discussion", send: "Send", status: "Dispute status",
      title: "Dispute", resolvedRefund: "Resolved — refunded", resolvedRelease: "Resolved — in seller's favour",
      openState: "Open", refund: "Refund buyer", release: "Release to seller",
      resolve: "Resolve dispute", submit: "Open dispute",
      openedAt: "Opened on", resolvedAt: "Closed on",
    },
    trusted: { title: "Trusted sellers", subtitle: "Our top-rated verified sellers — plus new talents to discover.", listings: "listing(s)" },
    rst: {
      tab: "RST Score",
      dashTitle: "RST Dashboard",
      dashSubtitle: "Platform trust indicators (simulated data).",
      configTitle: "RST Trust Score rules",
      configSubtitle: "Change weights and tiers without touching code. Saving recomputes every score.",
      totalOrders: "Total orders",
      delivered: "Delivered orders",
      disputes: "Disputes",
      disputeRate: "Dispute rate",
      refunds: "Refunds",
      refundRate: "Refund rate",
      avgResolution: "Avg. resolution time",
      hours: "h",
      revenue: "Simulated revenue",
      ordersByStatus: "Orders by status",
      topSellers: "Top sellers",
      score: "Score",
      tier: "Tier",
      deliveredCol: "Delivered",
      disputesCol: "Disputes",
      ratingCol: "Rating",
      sellerRules: "Sellers",
      buyerRules: "Buyers",
      weights: "Weights (points)",
      tiers: "Tiers",
      tierName: "Tier name",
      tierMin: "Minimum score",
      addTier: "Add a tier",
      removeTier: "Remove",
      save: "Save & recompute",
      saved: "Rules saved — scores recomputed",
      reset: "Reset to defaults",
      myScore: "My RST Trust Score",
      scoreHint: "Complete your deals on the platform to raise your score and unlock benefits.",
      loyaltyReplaced: "This score replaces a simple points program. It rewards reliability and paves the way for perks, better visibility and preferential terms.",
      fields: {
        points_per_delivered: "Points per delivered order",
        points_per_review: "Points per review received",
        points_per_rating_point: "Points per rating point (× avg rating)",
        points_per_1000_volume: "Points per 1000 FCFA delivered",
        points_per_month_seniority: "Points per month of seniority",
        dispute_penalty: "Penalty per dispute",
        points_per_completed_order: "Points per completed order",
        points_per_payment: "Points per correct payment",
      },
    },
    perks: {
      title: "Perks",
      badge: "Visible trust badge",
      visibility: "Better visibility",
      free_ads: "Free advertising",
      advanced_stats: "Advanced statistics",
      priority_support: "Priority support",
      priority_features: "Priority access to features",
      note: "These perks reward reliability. They never automatically grant the top spot: ranking always prioritises trust and service quality.",
    },
    progress: {
      view: "My progress",
      title: "My progress",
      subtitle: "Track your growth, metrics and RST perks.",
      currentTier: "Current tier",
      nextTier: "Next tier",
      maxTier: "Top tier reached",
      progressLabel: "Progress to {tier}",
      pointsToNext: "{n} points left",
      myPerks: "My perks",
      noPerks: "No perks at this tier yet — progress to unlock them.",
      allTiers: "Tiers & perks",
      metrics: "My metrics",
      delivered: "Delivered orders",
      totalOrders: "Total orders",
      successRate: "Success rate",
      responseRate: "Response rate",
      rating: "Reputation",
      disputes: "Disputes",
      disputeRate: "Dispute rate",
      revenue: "Sales (simulated)",
      spend: "Purchases (simulated)",
      paidOrders: "Honoured payments",
      salesEvolution: "Sales trend (6 months)",
      purchasesEvolution: "Purchases trend (6 months)",
      reputationEvolution: "Reputation trend (6 months)",
      nextBadge: "Next badge",
      badgeGoals: "Goals for the {badge} badge",
      needDeliveries: "{n} more delivered order(s)",
      needRating: "Average rating ≥ {r}",
      needLowDisputes: "Few disputes",
      simulator: "Goals to reach",
      count: "ord",
      rewardsTitle: "Rewards history",
      rewardsSubtitle: "Your earned RST points (missions and tiers).",
      rewardMission: "Mission completed",
      rewardTier: "New tier",
      rewardsEmpty: "No rewards yet — complete a mission to get started.",
    },
    hint: {
      orders_to_tier: "{n} more successful order(s) to reach the {tier} tier.",
      deliveries_for_badge: "{n} more delivered order(s) to earn the {badge} badge.",
      rating_for_badge: "Keep an average rating ≥ {r} to earn the {badge} badge.",
      respond_faster: "Reply faster to buyers to improve your visibility.",
      keep_going: "Keep it up — your good practices strengthen your RST trust.",
    },
    seller: { profile: "Seller profile", listings: "Listings", reputation: "Reputation", contactHidden: "Contact details stay hidden — chat through the platform." },
    missions: {
      title: "Missions & goals",
      subtitle: "Complete missions to earn bonus RST points.",
      adminTitle: "Missions & goals",
      adminSubtitle: "Enable missions and set bonus points. Saving recomputes every score.",
      enabled: "Enabled", bonus: "Bonus points", target: "Target",
      bonusPts: "+{n} RST pts", completed: "Completed", blocked: "Pending (resolve dispute)",
      sellerLabel: "Sellers", buyerLabel: "Buyers",
      labels: {
        deliver_3: "Deliver 3 orders",
        reviews_5: "Get 5 reviews",
        response_80: "Response rate ≥ 80%",
        no_dispute_10: "10 delivered orders with no dispute",
        honor_3: "Honour 3 orders",
        reviews_3: "Leave 3 verified reviews",
        complete_profile: "Complete my profile (phone + city)",
      },
    },
    market: {
      title: "Control Center", subtitle: "Your live poultry market dashboard.", simulated: "Simulated data",
      avgPrices: "Average prices by category", priceTrend: "Price trend", activity: "Activity", activityCurve: "Poultry activity", trend: "Trend", activityHint: "Order volume and market trends (indicative).", offers: "Offers posted",
      requests: "Requests posted", transactions: "Transactions", volume: "Traded volume",
      highDemand: "High-demand regions", deficit: "Deficit regions", topCategories: "Most searched categories",
      opportunities: "Today's opportunities", journal: "Market journal", morning: "Morning", evening: "Evening",
      tip: "Tip of the day", noData: "No data yet",
    },
    advantages: {
      title: "Why Ovolaay Hub?", subtitle: "Real benefits to buy and sell with confidence.",
      buyers: "For buyers", sellers: "For sellers",
      b1: "Purchase Protection", b2: "Verified professionals", b3: "Time savings", b4: "Purchase history",
      b5: "Support", b6: "Order tracking", b7: "Reliable suppliers",
      s1: "New customers", s2: "Reputation", s3: "Visibility", s4: "Free advertising by tier",
      s5: "Statistics", s6: "Guidance", s7: "Business growth",
    },
    future: {
      title: "Coming soon to Ovolaay Hub", subtitle: "New tools to run your whole business.", soon: "Soon",
      bandes: "Flock tracking", bandesDesc: "Track your flocks (D1→D45), weighing, vaccines and reminders.",
      partners: "Financial partners", partnersDesc: "Access tailored financing solutions.",
      club: "Ovolaay Hub Club", clubDesc: "Perks and a community of professionals.",
      coach: "Professional coach", coachDesc: "Guidance to grow your farm.",
      stats: "Advanced statistics", statsDesc: "Detailed analytics of your activity.",
      services: "Partner services", servicesDesc: "Useful products and services for the industry.",
    },
    profile: {
      activityType: "Activity type", farmType: "Farm type", species: "Species raised", farmSize: "Farm size",
      sellerAccount: "Seller account", buyerAccount: "Buyer account", verified: "Verified",
      farmName: "Farm name", email: "Email address", phone: "Phone", location: "Location", activity: "Activity", payout: "Payout method",
      profession: "Profession / Job (optional)", professionPlaceholder: "e.g. Restaurateur, reseller, cook…",
      save: "Save my profile", saved: "Profile updated",
    },
    verify: {
      status: "Account status", toVerify: "To verify", verified: "Verified",
      notice: "Your account is under verification. Some actions stay limited until the Ovolaay Hub team validates it.",
      sendDocs: "Send your documents (Tax ID, professional papers) to the Ovolaay Hub team:",
      private: "This information is never public.", whatsapp: "Official WhatsApp", email: "E-mail",
      nifLabel: "Tax ID (optional)", docTitle: "Verification (optional)",
      docHint: "Add an ID or Tax ID. Optional and strictly private.",
      viaWhatsapp: "You can also send via WhatsApp", addDoc: "Add a document",
    },
    protection: {
      title: "Ovolaay Hub Purchase Protection", amount: "Order amount", fee: "Ovolaay Hub Purchase Protection",
      total: "Total to pay", note: "Payment method fees are paid by the buyer. No cash payments.",
      adminTitle: "Purchase Protection (settings)", adminSubtitle: "Internal calculation, never shown as a percentage.",
      tier1Max: "Threshold (FCFA)", tier1Rate: "Internal rate (0–1) below threshold", tier2Cap: "Cap above threshold (FCFA)",
    },
  },
};
